import request from "_private/utils/request";

/**
 * 获取列表数据
 * @param {*} data
 */
export function FetchFindByPage(data) {
    return request({
        url: "/base/freezerLabel/findByPage",
        method: "post",
        data
    });
}

/**
 * 校验数据唯一性
 */
export function CheckNameUniqueData(data) {
    return request({
        url: "/base/freezerLabel/checkNameUniqueData",
        method: "post",
        data
    });
}

/**
 * 保存冷柜监测点信息
 * @param {*} data
 */
export function SaveFreezerLabelInfo(data) {
  return request({
      url: "/base/freezerLabel/saveFreezerLabelInfo",
      method: "post",
      data
  });
}

/**
 * 查询单个冷柜监测点信息
 * @param {*} data
 */
export function FindFreezerLabelInfoById(data) {
  return request({
      url: "/base/freezerLabel/findFreezerLabelInfoById",
      method: "post",
      data
  });
}

/**
 * 删除冷柜信息
 * @param {*} data
 */
export function DeleteFreezerLabelInfoByIds(data) {
  return request({
      url: "/base/freezerLabel/deleteFreezerLabelInfoByIds",
      method: "post",
      data
  });
}



